import { inject as o } from "vue";
import { OptionalInjectionFacade as a } from "./optional-injection-facade.js";
class n extends a {
  defaultFactory;
  constructor(t, e) {
    super(t), this.defaultFactory = e;
  }
  useInjection() {
    return o(this.key, this.defaultFactory, !0);
  }
}
export {
  n as OptionalWithDefaultInjectionFacade
};
//# sourceMappingURL=optional-with-default-injection-facade.js.map
